import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="mx-auto flex min-h-[60vh] max-w-xl flex-col items-center justify-center px-4 py-24 text-center">
      <p className="font-mono2 text-sm text-blue-600">404</p>
      <h1 className="mt-3 font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">Page not found</h1>
      <p className="mt-3 text-slate-600">The page you're looking for doesn't exist or has moved.</p>
      <div className="mt-8 flex gap-3">
        <Link to="/"><Button data-testid="not-found-home" variant="outline" className="border-slate-200">Home</Button></Link>
        <Link to="/shop"><Button data-testid="not-found-shop" className="btn-metallic font-semibold">Explore Research</Button></Link>
      </div>
    </div>
  );
}
